// extracted by mini-css-extract-plugin
export default {"Wrapper":"RootFolder_Wrapper__OOuoD","Icon":"RootFolder_Icon__rEWmn","ProjectName":"RootFolder_ProjectName__QTDjf","Active":"RootFolder_Active__jzoE+"};